import React from 'react';

import styles from './Breadcrumbs.scss';

function BreadcrumbItem(props) {
    const {
        children,
        isActive,
    } = props;

    const ariaAttribute = isActive && {
        'aria-current': 'page',
    };

    return (
        <li
            className={styles.listItem}
            {...ariaAttribute}
        >
            {children}
        </li>
    );
}

function Breadcrumbs(props) {
    const {
        children,
    } = props;

    return (
        <nav
            aria-label="Breadcrumb"
        >
            <ol
                className={styles.breadcrumbList}
            >
                {children}
            </ol>
        </nav>
    );
}

export {
    BreadcrumbItem,
    Breadcrumbs,
};
